module.exports = __webpack_public_path__ + "static/media/04.0345161c.png";